<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :height="320"
            :fixed-header="true"
            :search="search"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Perfil</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>

                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-text-field
                                                outlined
                                                v-model="editedItem.descricao_perfil"
                                                label="Nome Perfil*"
                                                autofocus
                                                :error-messages="nameErrors"
                                                @input="$v.editedItem.descricao_perfil.$touch()"
                                                @blur="$v.editedItem.descricao_perfil.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.src_modulo="{ item }">
                <v-icon>{{item.src_modulo}}</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Módulo"
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    title="Remover Módulo"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import AclAPI from "./../../api/acl";

    export default {
        name: "Acl",
        data: () => ({
            dialog: false,
            atualizar: 0,
            search: '',
            headers: [
                {
                    text: 'ID',
                    value: 'idperfil',
                },
                {
                    text: 'Perfil',
                    align: 'left',
                    value: 'descricao_perfil',
                },
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                descricao_perfil: '',
            },
            defaultItem: {
                descricao_perfil: '',

            },
        }),

        validations: {
            editedItem: {
                descricao_perfil: {
                    required,
                },

            }
        },
        computed: {
            nameErrors() {
                const errors = []
                if (!this.$v.editedItem.descricao_perfil.$dirty) return errors
                !this.$v.editedItem.descricao_perfil.required && errors.push('Campo Obrigatório.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Perfil' : 'Editar Perfil'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                AclAPI.getPerfis(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.perfis;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover o Perfil?')) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.delPerfil(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.editedItem = {}

                                    this.initialize();

                                    //atualizar permissao
                                    this.$emit('atualizarPermUsu', this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }else{
                    this.editedItem = {}
                }

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.addPerfil(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                    //atualizar permissao
                                    this.$emit('atualizarPermUsu', this.atualizar += 1)

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>